

/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

export class EventAdjudicator {

  constructor(public id: string, public name: string, public title: string, public photoUrl: string, public bio: string[] = []) {

  }

  static fromSnapshot(key: string, {name, title, photo, paragraphs}) : EventAdjudicator {
    return new EventAdjudicator(key, name, title, photo, paragraphs)
  }

  static fromSnapshots(snapshots: any) : EventAdjudicator[] {
    let adjudicators: EventAdjudicator[] = [];

    snapshots.forEach(snap => {
      adjudicators.push(EventAdjudicator.fromSnapshot(snap.key, snap.val()));
    });

    return adjudicators;
  }
}



// WEBPACK FOOTER //
// ./src/models/schedule/Adjudicator.ts